import { Directive, ElementRef, OnDestroy, OnInit, inject, input } from '@angular/core';
import { BELOW_TOP_MENU, isUnderTopMenu } from 'app/framework/top-menu-scroll';
import { TopMenuTitleService } from 'app/shared/services/top-menu-title.service';

/** Shows the host's text, or the given title, in the top menu once the host has scrolled under it. */
@Directive({
  selector: '[appTopMenuTitle]',
  standalone: false,
})
export class TopMenuTitleDirective implements OnInit, OnDestroy {
  public readonly title = input('', { alias: 'appTopMenuTitle' });

  private readonly host: ElementRef<HTMLElement> = inject(ElementRef);
  private readonly topMenuTitle = inject(TopMenuTitleService);

  private observer: IntersectionObserver | null = null;

  ngOnInit(): void {
    if (typeof IntersectionObserver === 'undefined') {
      return;
    }

    this.observer = new IntersectionObserver((entries) => this.update(entries[entries.length - 1]), BELOW_TOP_MENU);
    this.observer.observe(this.host.nativeElement);
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
    this.topMenuTitle.hide(this);
  }

  private update(entry: IntersectionObserverEntry): void {
    if (isUnderTopMenu(entry)) {
      this.topMenuTitle.show(this, this.title() || this.host.nativeElement.textContent?.trim() || '');
    } else {
      this.topMenuTitle.hide(this);
    }
  }
}
